import LocalStorage from "../tools/LocalStorage";
import Info from "../tools/Info";

const generateDeviceId=()=> {
    if(LocalStorage.getDeviceId() === "") {
        const deviceIdLength = 70;

        let result = `${Info.deviceInfo.mobileVendor}-${Info.deviceInfo.mobileModel}-${Info.deviceInfo.osName}-`;

        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let charactersLength = characters.length;
        for ( let i = 0; i < deviceIdLength; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        LocalStorage.setDeviceId(result);
    }
}
export {generateDeviceId}